module.exports = __webpack_public_path__ + "images/bb3bfe9e9daecacad8760064e08865cf.png";